"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set_login_status = exports.set_address = exports.set_provider_wallet = exports.set_chain_id = void 0;
var constants_1 = require("../constants");
var set_chain_id = function set_chain_id(id) {
  return {
    type: constants_1.SET_CHAIN_ID,
    payload: id
  };
};
exports.set_chain_id = set_chain_id;
var set_provider_wallet = function set_provider_wallet(wallet) {
  return {
    type: constants_1.SET_RROVIDER_WALLET,
    payload: wallet
  };
};
exports.set_provider_wallet = set_provider_wallet;
var set_address = function set_address(address) {
  return {
    type: constants_1.SET_ADDRESS,
    payload: address
  };
};
exports.set_address = set_address;
var set_login_status = function set_login_status(status) {
  return {
    type: constants_1.SET_LOGIN_STATUS,
    payload: status
  };
};
exports.set_login_status = set_login_status;